// Overgezet uit naslag/server/server/generateData/tasksPerCategory/Magazijn.ts.
import { TaskType } from '../../types/tasks.js';
import { InGameEffect } from '../../types/inGameEffect.js';
const buy = [
    {
        type: InGameEffect.buySparepart,
        description: 'Bestel 2 parts via de bestellijst',
    },
];
const choose = [
    {
        type: InGameEffect.chooseSparepart,
        description: 'Bekijk 2 parts, behoud 1 en stop de andere terug of verkoop een part',
    },
];
export const MagazijnTaken = [
    {
        _id: 'magazijn0',
        type: TaskType.magazijn,
        title: 'Magazijn inventarisatie',
        cost: 500,
        description: 'Voer een opruimproject in het magazijn en zoek onderdelen',
        inGameEffectDescription: 'Bekijk 2 parts, behoud 1 en stop de andere terug of verkoop een part',
        inGameEffect: [InGameEffect.chooseSparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: choose,
    },
    {
        _id: 'magazijn1',
        type: TaskType.magazijn,
        title: 'Magazijn inventarisatie',
        cost: 500,
        description: 'Ruim op en alloceer onderdelen',
        inGameEffectDescription: 'Bekijk 2 parts, behoud 1 en stop de andere terug of verkoop een part',
        inGameEffect: [InGameEffect.chooseSparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: choose,
    },
    {
        _id: 'magazijn2',
        type: TaskType.magazijn,
        title: 'Magazijn inkoop',
        cost: 500,
        description: 'Koop nieuwe onderdelen in',
        inGameEffectDescription: 'Bestel 2 parts via de bestellijst',
        inGameEffect: [InGameEffect.buySparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: buy,
    },
    {
        _id: 'magazijn3',
        type: TaskType.magazijn,
        title: 'Magazijn inventarisatie',
        cost: 1000,
        description: 'Voer een opruimproject in het magazijn en zoek onderdelen',
        inGameEffectDescription: 'Bekijk 2 parts, behoud 1 en stop de andere terug of verkoop een part',
        inGameEffect: [InGameEffect.chooseSparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: choose,
    },
    {
        _id: 'magazijn4',
        type: TaskType.magazijn,
        title: 'Magazijn inkoop',
        cost: 1000,
        description: 'Koop nieuwe onderdelen in',
        inGameEffectDescription: 'Bestel 2 parts via de bestellijst',
        inGameEffect: [InGameEffect.buySparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: buy,
    },
    {
        _id: 'magazijn5',
        type: TaskType.magazijn,
        title: 'Magazijn inventarisatie',
        cost: 1000,
        description: 'Ruim op en alloceer onderdelen aan assets',
        inGameEffectDescription: 'Bekijk 2 parts, behoud 1 en stop de andere terug of verkoop een part',
        inGameEffect: [InGameEffect.chooseSparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: choose,
    },
    {
        _id: 'magazijn6',
        type: TaskType.magazijn,
        title: 'Magazijn inkoop',
        cost: 1000,
        description: 'Koop nieuwe onderdelen in',
        inGameEffectDescription: 'Bestel 2 parts via de bestellijst',
        inGameEffect: [InGameEffect.buySparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: buy,
    },
    {
        _id: 'magazijn7',
        type: TaskType.magazijn,
        title: 'Magazijn inventarisatie',
        cost: 1000,
        description: 'Voer een opruimproject in het magazijn en gooi een onderdeel weg',
        inGameEffectDescription: 'Bekijk 2 parts, behoud 1 en stop de andere terug of verkoop een part',
        inGameEffect: [InGameEffect.chooseSparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: choose,
    },
    {
        _id: 'magazijn8',
        type: TaskType.magazijn,
        title: 'Magazijn inventarisatie',
        cost: 1000,
        description: 'Ruim op en gooi een onderdeel weg',
        inGameEffectDescription: 'Bekijk 2 parts, behoud 1 en stop de andere terug of verkoop een part',
        inGameEffect: [InGameEffect.chooseSparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: choose,
    },
    {
        _id: 'magazijn9',
        type: TaskType.magazijn,
        title: 'Magazijn inkoop',
        cost: 1000,
        description: 'Koop nieuwe onderdelen in',
        inGameEffectDescription: 'Bestel 2 parts via de bestellijst',
        inGameEffect: [InGameEffect.buySparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: buy,
    },
    {
        _id: 'magazijn10',
        type: TaskType.magazijn,
        title: 'Magazijn inkoop',
        cost: 1000,
        description: 'Koop nieuwe onderdelen in',
        inGameEffectDescription: 'Bestel 2 parts via de bestellijst',
        inGameEffect: [InGameEffect.buySparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: buy,
    },
    {
        _id: 'magazijn11',
        type: TaskType.magazijn,
        title: 'Magazijn inkoop',
        cost: 1000,
        description: 'Koop nieuwe onderdelen in',
        inGameEffectDescription: 'Bestel 2 parts via de bestellijst',
        inGameEffect: [InGameEffect.buySparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: buy,
    },
    {
        _id: 'magazijn12',
        type: TaskType.magazijn,
        title: 'Magazijn inkoop',
        cost: 1000,
        description: 'Koop nieuwe onderdelen in',
        inGameEffectDescription: 'Bestel 2 parts via de bestellijst',
        inGameEffect: [InGameEffect.buySparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: buy,
    },
    {
        _id: 'magazijn13',
        type: TaskType.magazijn,
        title: 'Magazijn inkoop',
        cost: 1000,
        description: 'Koop nieuwe onderdelen in',
        inGameEffectDescription: 'Bestel 2 parts via de bestellijst',
        inGameEffect: [InGameEffect.buySparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: buy,
    },
    {
        _id: 'magazijn14',
        type: TaskType.magazijn,
        title: 'Magazijn inkoop',
        cost: 1500,
        description: 'Koop nieuwe onderdelen in',
        inGameEffectDescription: 'Bestel 2 parts via de bestellijst',
        inGameEffect: [InGameEffect.buySparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: buy,
    },
    {
        _id: 'magazijn15',
        type: TaskType.magazijn,
        title: 'Magazijn inkoop',
        cost: 1500,
        description: 'Koop nieuwe onderdelen in',
        inGameEffectDescription: 'Bestel 2 parts via de bestellijst',
        inGameEffect: [InGameEffect.buySparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: buy,
    },
    {
        _id: 'magazijn16',
        type: TaskType.magazijn,
        title: 'Magazijn inkoop',
        cost: 1500,
        description: 'Koop nieuwe onderdelen in',
        inGameEffectDescription: 'Bestel 2 parts via de bestellijst',
        inGameEffect: [InGameEffect.buySparepart],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: buy,
    },
];
